<template>
    <div>
      <div class="e-card" style="margin-top: 5px">
        <div
          class="e-card-content"
          style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 5%"
        >
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="paymentStatus"
            placeholder="Invoice Status"
            v-model="invoiceStatusType"
          />
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource='operationalPrices'
            :fields='registrationFields'
            placeholder='Registration *'
            v-model='registrationID' >
          </ejs-dropdownlist>
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="certificationTypes"
            placeholder="Type of Certification"
            v-model="certificateType"
          />
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="registrationStatus"
            placeholder="Registration Status"
            v-model="registrationStatusType"
          />
          <div style="width: 2%; padding-top: 4%">
            <ejs-button
              type="button"
              cssClass="e-danger"
              v-on:click.native="onOkButtonClick"
              :disabled="isButtonDisabled"
            >
              Search
            </ejs-button>
          </div>
        </div>
      </div>
      <div style="margin-top: 5px">
        <ejs-grid
          ref="grid"
          :dataSource="reports"
          :allowSorting="true"
          :allowPaging="true"
          :allowTextWrap="true"
          :pageSettings="pageSettings"
          :toolbar="toolbarOptions"
          :created="created"
          :toolbarClick="toolbarClick"
          :excelQueryCellInfo="excelQueryCellInfo"
          :allowExcelExport="true"
          height="100%"
          width="100%"
        >
          <e-columns>
            <e-column field="siteID"
            headerText="Site #"
            textAlign="Left"
            width="170" />
            <e-column
              field="siteName"
              headerText="Site Name"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="siteAddress"
              headerText="Site Address"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="municipality"
              headerText="Municipality"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="ownerID"
              headerText="Owner ID"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="ownerDetails"
              headerText="Owner Details"
              textAlign="Left"
              width="300"
            />
            <e-column
              field="ownerName"
              headerText="Legal Name"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="ownerAddress"
              headerText="Owner Address"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="operatorName"
              headerText="Operator Name"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="operatorNumber"
              headerText="Operator Number"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="operatorAddress"
              headerText="Operator Address"
              textAlign="Left"
              width="220"
            />
            <e-column
              field="registrationDesc"
              headerText="Registration Period"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="registrationStatusType"
              headerText="Registration Status"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="holdCertificate"
              headerText="Hold Certificate"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="numberOfTanks"
              headerText="Number of Tanks"
              textAlign="Left"
              width="150"
            />
            <e-column
            field="invoiceDate"
            headerText="Invoice Date"
            textAlign="Left"
            type="date"
            :format="gridDateFormat"
            width="170"
          />
          <e-column
              field="invoiceAmount"
              headerText="Invoice Amount"
              textAlign="Left"
              format="C2"
              width="150"
            />
            <e-column
            field="paymentDate"
            headerText="Date Paid"
            textAlign="Left"
            type="date"
            :format="gridDateFormat"
            width="150"
          />
          <e-column
              field="certificateType"
              headerText="Certificate Type"
              textAlign="Left"
              width="150"
            />
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getOperationgPermitReports, getRegistrationList5 } from '../services/site-info-api';

import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'OperatingPermits',
  data() {
    return {
      invoiceStatusType: null,
      registrationID: null,
      certificateType: null,
      registrationStatusType: null,
      operationalPrices: null,
      paymentStatus: ['All', 'Paid', 'Unpaid'],
      certificationTypes: ['All', 'Temporary', 'Annual'],
      registrationStatus: ['All', 'Registered', 'Not Registered'],
      reports: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 15 },
      registrationFields: { text: 'registrationDesc', value: 'registrationID' },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return !this.invoiceStatusType || !this.registrationID || !this.certificateType || !this.registrationStatusType;
    },
  },
  async created() {
    // eslint-disable-next-line no-return-assign
    await getRegistrationList5().then((res) => (this.operationalPrices = res.data));
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      await getOperationgPermitReports(this.invoiceStatusType, this.registrationID, this.certificateType, this.registrationStatusType)
        .then((res) => {
          this.reports = res.data;
        });
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'invoiceDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'paymentDate':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Operating Permits.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
